import { TReduxActions } from '../../actions';
import { EDesktopListingActionType } from '../../actions/desktopListing';
import { EDesktopListingView, IDesktopListingState } from '../../types/desktopListing';

const defaultState: IDesktopListingState = {
  view: EDesktopListingView.VISIBLE,
};

export function desktopListingReducer(state = defaultState, action: TReduxActions): IDesktopListingState {
  switch (action.type) {
    case EDesktopListingActionType.SetVisible:
      return { view: EDesktopListingView.VISIBLE };
    case EDesktopListingActionType.SetHidden:
      return { view: EDesktopListingView.HIDDEN };
    default:
      return state;
  }
}
